import * as types from './constants';

// Update Lookbook Order Fulfillment Package
export const updateLookbookOrderFulfillmentPackageRequest = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_REQUEST, payload: data }
);

export const updateLookbookOrderFulfillmentPackageDone = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_DONE, payload: data }
);

export const updateLookbookOrderFulfillmentPackageFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_FAILED, payload: errors }
);

export const updateLookbookOrderFulfillmentPackageClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookOrderFulfillmentPackageReset = () => (
  { type: types.UPDATE_LOOKBOOK_ORDER_FULFILLMENT_PACKAGE_RESET }
);
